// @flow

import React, { type Node } from 'react';
import classNames from '@ta/common.classnames';
import styles from './Header.css';

type Props = {|
  titleText: Node,
  subtitleText?: Node,
  withBackground?: boolean,
|};

/**
 * A title and optional subtitle for a screen
 */
const Header = ({ titleText, subtitleText, withBackground = true }: Props) => (
  <>
    <div className={classNames(styles.titleText, { [styles.withBackground]: withBackground })}>
      {titleText}
    </div>

    {subtitleText && (
      <div className={classNames(styles.subtitleText, { [styles.withBackground]: withBackground })}>
        {subtitleText}
      </div>
    )}
  </>
);

export default Header;
